//盘谷自定义组件库
import Main from '@/views/Main.vue'

const panguComponentRouter = []

// 所有上面定义的路由都要写在下面的routers里
export default panguComponentRouter
